import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import moment, { months } from "moment";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";
import { calculateColumnTotal, getMonthName } from "../General/Utility";

import imgLogo from "../../assets/images/logo/logo_notext.svg";

import "../../assets/css/result-card.css";

const PrintResultCards = () => {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [listOfLedger, setLedger] = useState([]);
  const [showSecondExam, setShowSecondExam] = useState(false);
  const [showThirdExam, setShowThirdExam] = useState(false);
  const [showFourthExam, setShowFourthExam] = useState(false);

  useEffect(() => {
    document.title = "Print Result Cards";

    const printStyle = document.createElement("style");
    printStyle.setAttribute("data-result-card-print", "true");
    printStyle.innerHTML = `
      @page {
        size: A4 portrait;
        margin: 0.5in !important;
      }
    `;
    document.head.appendChild(printStyle);

    return () => {
      if (printStyle.parentNode) {
        printStyle.parentNode.removeChild(printStyle);
      }
    };
  }, []);

  useEffect(() => {
    setLoading(true);
    // Get the URL parameters
    const urlParams = new URLSearchParams(window.location.search);

    // Retrieve individual parameter values
    const FirstExamID = urlParams.get("FirstExamID");
    const SecondExamID = urlParams.get("SecondExamID");
    const ThirdExamID = urlParams.get("ThirdExamID");
    const FourthExamID = urlParams.get("FourthExamID");
    const Wing_Id = urlParams.get("WingId");
    const Class_Id = urlParams.get("ClassId");
    const Section_Id = urlParams.get("SectionId");

    const parseExamId = (value) => {
      const n = parseInt(value || "0", 10);
      return Number.isNaN(n) ? 0 : n;
    };

    setShowSecondExam(parseExamId(SecondExamID) > 0);
    setShowThirdExam(parseExamId(ThirdExamID) > 0);
    setShowFourthExam(parseExamId(FourthExamID) > 0);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      FirstExamID: FirstExamID,
      SecondExamID: SecondExamID,
      ThirdExamID: ThirdExamID,
      FourthExamID: FourthExamID,
      Wing_Id: Wing_Id,
      Class_Id: Class_Id,
      Section_Id: Section_Id,
    };

    //console.log(data);
    var api_config = {
      method: "post",
      url: config.base_url + "Exam/GetResultCard",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    //console.log(api_config);

    axios(api_config)
      .then(function (response) {
        //console.log(response.data);
        setLedger(response.data.ListofStudents);
        setLoading(false);
      })
      .catch(function (error) {
        //console.log(error);
      });
  }, []);

  const toNumber = (value) => {
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
  };

  const buildCumulativeRows = (item) => {
    const first = item.ListofFirstTermExamData || [];
    const second = item.ListofSecondTermExamData || [];
    const third = item.ListofThirdTermExamData || [];
    const fourth = item.ListofFourthTermExamData || [];

    return first.map((subj, idx) => {
      let total = toNumber(subj.Total_Marks);
      let obtained = toNumber(subj.Obtained_Marks);

      if (showSecondExam && second[idx]) {
        total += toNumber(second[idx].Total_Marks);
        obtained += toNumber(second[idx].Obtained_Marks);
      }
      if (showThirdExam && third[idx]) {
        total += toNumber(third[idx].Total_Marks);
        obtained += toNumber(third[idx].Obtained_Marks);
      }
      if (showFourthExam && fourth[idx]) {
        total += toNumber(fourth[idx].Total_Marks);
        obtained += toNumber(fourth[idx].Obtained_Marks);
      }

      return { total, obtained };
    });
  };

  const sumMarks = (rows, field) =>
    (rows || []).reduce((sum, row) => sum + toNumber(row[field]), 0);

  const visibleExamColumns =
    1 +
    (showSecondExam ? 1 : 0) +
    (showThirdExam ? 1 : 0) +
    (showFourthExam ? 1 : 0) +
    1; // cumulative
  const firstTermWidth = visibleExamColumns <= 2 ? "58%" : `${Math.max(28, 100 / visibleExamColumns + 8)}%`;
  const otherTermWidth = `${(100 - parseFloat(firstTermWidth)) / Math.max(1, visibleExamColumns - 1)}%`;

  const totalCards = listOfLedger ? listOfLedger.length : 0;

  return (
    <>
      {loading ? (
        <div className="d-flex align-items-center justify-content-center p-5">
          <Spinner animation="border" role="status" className="me-2" />
          <span>Loading result cards…</span>
        </div>
      ) : (
        listOfLedger &&
        listOfLedger.map((item, index) => {
          const cumulativeRows = buildCumulativeRows(item);
          const cumulativeTotalMarks = cumulativeRows.reduce(
            (sum, row) => sum + row.total,
            0
          );
          const cumulativeObtainedMarks = cumulativeRows.reduce(
            (sum, row) => sum + row.obtained,
            0
          );

          return (
          <Page
            key={index}
            orientation="portrait"
            size="a4"
            className={`result-cards-print${index === totalCards - 1 ? " result-cards-print-last" : ""}`}
          >
            <div className="subpage result-card">
              <div className="school-head">
                <table>
                  <tbody>
                    <tr>
                      <td style={{ width: "14%", verticalAlign: "middle", textAlign: "left" }}>
                        <img
                          src={imgLogo}
                          alt="School Logo"
                          className="result-card-logo"
                        />
                      </td>
                      <td style={{ width: "86%", textAlign: "center", verticalAlign: "middle" }}>
                        <h2>
                          DISTRICT PUBLIC SCHOOL AND COLLEGE, KASUR
                        </h2>
                        <h4>
                          PROVISIONAL RESULT INTIMATION
                          <br />
                          {item.Father_CNIC}
                        </h4>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="student-info-header">
                <table>
                  <tbody>
                    <tr>
                      <td style={{ width: "85%" }}>
                        <table>
                          <tbody>
                            <tr>
                              <td>
                                <div className="option">
                                  <span className="label">Name:</span>
                                  <span className="value">
                                    {item.Student_Name}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className="option">
                                  <span className="label">Father’s Name:</span>
                                  <span className="value">
                                    {item.Father_Name}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className="option">
                                  <span className="label">Result:</span>
                                  <span className="value"></span>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table>
                          <tbody>
                            <tr>
                              <td>
                                <div className="option">
                                  <span className="label">
                                    Class / Section:{" "}
                                  </span>
                                  <span className="value">
                                    {item.Class_Name}/{item.Section_Name}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className="option">
                                  <span className="label">Sr. No:</span>
                                  <span className="value">
                                    {item.Serial_No}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className="option">
                                  <span className="label">Reg. No.</span>
                                  <span className="value">
                                    {item.Registration_No}
                                  </span>
                                </div>
                              </td>
                              <td style={{ width: "150px" }}>
                                <div className="option">
                                  <span className="label">Date:</span>
                                  <span className="value">
                                    {moment().format("DD MMM YYYY")}
                                  </span>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table>
                          <tbody>
                            <tr>
                              <td>
                                <div className="option">
                                  <span className="label">Address:</span>
                                  <span className="value">
                                    {item.Permanent_Address}
                                  </span>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td
                        style={{
                          width: "15%",
                          verticalAlign: "top",
                          textAlign: "right",
                        }}
                      >
                        {item.Registration_No ? (
                          <img
                            src={`/student_images/${item.Registration_No}.jpg`}
                            alt=""
                            className="result-card-photo"
                            onError={(e) => {
                              e.currentTarget.style.visibility = "hidden";
                            }}
                          />
                        ) : null}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="result-card-body">
                <table className="marks-layout">
                  <tbody>
                    <tr>
                      <td style={{ width: firstTermWidth, verticalAlign: "top" }}>
                        <table className="table-bordered">
                          <thead style={{ textAlign: "center" }}>
                            <tr className="greyback">
                              <th colSpan="3">First Term</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="greyback">
                              <td className="subject">
                                <strong>Subject</strong>
                              </td>
                              <td>
                                <strong>Total Marks</strong>
                              </td>
                              <td>
                                <strong>Obtained Marks</strong>
                              </td>
                            </tr>

                            {(item.ListofFirstTermExamData || []).map(
                              (firstexam, subjectIndex) => (
                                <tr key={`first-${subjectIndex}`}>
                                  <td className="subject-name">{firstexam.Name}</td>
                                  <td>
                                    {toNumber(firstexam.Total_Marks) > 0
                                      ? firstexam.Total_Marks
                                      : "\u00A0"}
                                  </td>
                                  <td>{firstexam.Obtained_Marks}</td>
                                </tr>
                              )
                            )}
                            <tr className="marks-total-row">
                              <td><strong>Total</strong></td>
                              <td>
                                <strong>
                                  {sumMarks(item.ListofFirstTermExamData, "Total_Marks")}
                                </strong>
                              </td>
                              <td>
                                <strong>
                                  {sumMarks(item.ListofFirstTermExamData, "Obtained_Marks")}
                                </strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>

                      {showSecondExam && (
                        <td style={{ width: otherTermWidth, verticalAlign: "top" }}>
                          <table className="table-bordered">
                            <thead style={{ textAlign: "center" }}>
                              <tr className="greyback">
                                <th colSpan="2">Second Term</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr className="greyback">
                                <td className="marks">
                                  <strong>Total Marks</strong>
                                </td>
                                <td>
                                  <strong>Obtained Marks</strong>
                                </td>
                              </tr>
                              {(item.ListofSecondTermExamData || []).map(
                                (secondexam, subjectIndex) => (
                                  <tr key={`second-${subjectIndex}`}>
                                    <td>
                                      {toNumber(secondexam.Total_Marks) > 0
                                        ? secondexam.Total_Marks
                                        : "\u00A0"}
                                    </td>
                                    <td>{secondexam.Obtained_Marks}</td>
                                  </tr>
                                )
                              )}
                              <tr className="marks-total-row">
                                <td>
                                  <strong>
                                    {sumMarks(item.ListofSecondTermExamData, "Total_Marks")}
                                  </strong>
                                </td>
                                <td>
                                  <strong>
                                    {sumMarks(item.ListofSecondTermExamData, "Obtained_Marks")}
                                  </strong>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      )}

                      {showThirdExam && (
                        <td style={{ width: otherTermWidth, verticalAlign: "top" }}>
                          <table className="table-bordered">
                            <thead style={{ textAlign: "center" }}>
                              <tr className="greyback">
                                <th colSpan="2">Third Term</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr className="greyback">
                                <td className="marks">
                                  <strong>Total Marks</strong>
                                </td>
                                <td>
                                  <strong>Obtained Marks</strong>
                                </td>
                              </tr>
                              {(item.ListofThirdTermExamData || []).map(
                                (thirdexam, subjectIndex) => (
                                  <tr key={`third-${subjectIndex}`}>
                                    <td>
                                      {toNumber(thirdexam.Total_Marks) > 0
                                        ? thirdexam.Total_Marks
                                        : "\u00A0"}
                                    </td>
                                    <td>{thirdexam.Obtained_Marks}</td>
                                  </tr>
                                )
                              )}
                              <tr className="marks-total-row">
                                <td>
                                  <strong>
                                    {sumMarks(item.ListofThirdTermExamData, "Total_Marks")}
                                  </strong>
                                </td>
                                <td>
                                  <strong>
                                    {sumMarks(item.ListofThirdTermExamData, "Obtained_Marks")}
                                  </strong>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      )}

                      {showFourthExam && (
                        <td style={{ width: otherTermWidth, verticalAlign: "top" }}>
                          <table className="table-bordered">
                            <thead style={{ textAlign: "center" }}>
                              <tr className="greyback">
                                <th colSpan="2">Fourth Term</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr className="greyback">
                                <td className="marks">
                                  <strong>Total Marks</strong>
                                </td>
                                <td>
                                  <strong>Obtained Marks</strong>
                                </td>
                              </tr>
                              {(item.ListofFourthTermExamData || []).map(
                                (fourthexam, subjectIndex) => (
                                  <tr key={`fourth-${subjectIndex}`}>
                                    <td>
                                      {toNumber(fourthexam.Total_Marks) > 0
                                        ? fourthexam.Total_Marks
                                        : "\u00A0"}
                                    </td>
                                    <td>{fourthexam.Obtained_Marks}</td>
                                  </tr>
                                )
                              )}
                              <tr className="marks-total-row">
                                <td>
                                  <strong>
                                    {sumMarks(item.ListofFourthTermExamData, "Total_Marks")}
                                  </strong>
                                </td>
                                <td>
                                  <strong>
                                    {sumMarks(item.ListofFourthTermExamData, "Obtained_Marks")}
                                  </strong>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      )}

                      <td style={{ width: otherTermWidth, verticalAlign: "top" }}>
                        <table className="table-bordered">
                          <thead style={{ textAlign: "center" }}>
                            <tr className="greyback">
                              <th colSpan="2">Cumulative</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="greyback">
                              <td className="marks">
                                <strong>Total Marks</strong>
                              </td>
                              <td>
                                <strong>Obtained Marks</strong>
                              </td>
                            </tr>
                            {cumulativeRows.map((row, subjectIndex) => (
                              <tr key={`cum-${subjectIndex}`}>
                                <td>{row.total > 0 ? row.total : "\u00A0"}</td>
                                <td>{row.obtained.toFixed(2)}</td>
                              </tr>
                            ))}
                            <tr className="marks-total-row">
                              <td>
                                <strong>{cumulativeTotalMarks}</strong>
                              </td>
                              <td>
                                <strong>{cumulativeObtainedMarks.toFixed(2)}</strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="feedback">
                <table>
                  <tbody>
                    <tr>
                      <td style={{ width: "52%", verticalAlign: "top" }}>
                        <table className="table-bordered feedback-rating">
                          <colgroup>
                            <col className="feedback-label-col" />
                            <col className="feedback-tick-col" />
                            <col className="feedback-tick-col" />
                            <col className="feedback-tick-col" />
                            <col className="feedback-tick-col" />
                          </colgroup>
                          <tbody>
                            <tr className="thead greyback">
                              <th colSpan="5" style={{ textAlign: "center" }}>
                                Your Child as a Learner
                              </th>
                            </tr>
                            <tr>
                              <td className="feedback-label"></td>
                              <td className="feedback-tick">
                                <div className="smiley">
                                  <img src="images/smileys/rarely.png" alt="" />
                                  <span>Rarely</span>
                                </div>
                              </td>
                              <td className="feedback-tick">
                                <div className="smiley">
                                  <img
                                    src="images/smileys/sometime.png"
                                    alt=""
                                  />
                                  <span>Sometimes</span>
                                </div>
                              </td>
                              <td className="feedback-tick">
                                <div className="smiley">
                                  <img src="images/smileys/most.png" alt="" />
                                  <span>Mostly</span>
                                </div>
                              </td>
                              <td className="feedback-tick">
                                <div className="smiley">
                                  <img src="images/smileys/always.png" alt="" />
                                  <span>Always</span>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td className="feedback-label">Listens class attentively</td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                            </tr>
                            <tr>
                              <td className="feedback-label">Learns and asks questions</td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                            </tr>
                            <tr>
                              <td className="feedback-label">Responsible with homework</td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                            </tr>
                            <tr>
                              <td className="feedback-label">Works neatly and orderly</td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                            </tr>
                            <tr className="thead greyback">
                              <th colSpan="5" style={{ textAlign: "center" }}>
                                Your child's social and personal development
                              </th>
                            </tr>
                            <tr>
                              <td className="feedback-label">Remains pleasant in Class</td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                            </tr>
                            <tr>
                              <td className="feedback-label">Behaves well with classmates</td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                            </tr>
                            <tr>
                              <td className="feedback-label">Respects his elders</td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                            </tr>
                            <tr>
                              <td className="feedback-label">Sensitive to other's feelings</td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                            </tr>
                            <tr>
                              <td className="feedback-label">Hates the wrong doings</td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                            </tr>
                          </tbody>
                        </table>
                        <table className="position-table">
                          <tbody>
                            <tr>
                              <td colSpan="5">
                                <h4
                                  style={{
                                    textAlign: "center",
                                    margin: "8pt 0 4pt 0",
                                    fontSize: "11pt",
                                  }}
                                >
                                  Position in Class
                                </h4>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <span>1</span>
                                <div className="position">
                                  ({item.FirstTermPercentMarks}%)
                                  {item.FirstTermClass_Position}
                                </div>
                              </td>
                              {showSecondExam && (
                                <td>
                                  <span>2</span>
                                  <div className="position">
                                    ({item.SecondTermPercentMarks}%)
                                    {item.SecondTermClass_Position}
                                  </div>
                                </td>
                              )}
                              {showThirdExam && (
                                <td>
                                  <span>3</span>
                                  <div className="position">
                                    ({item.ThirdTermPercentMarks}%)
                                    {item.ThirdTermClass_Position}
                                  </div>
                                </td>
                              )}
                              {showFourthExam && (
                                <td>
                                  <span>4</span>
                                  <div className="position">
                                    ({item.FourthTermPercentMarks}%)
                                    {item.FourthTermClass_Position}
                                  </div>
                                </td>
                              )}
                              <td>
                                <span>Composite</span>
                                <div className="position">
                                  ({item.FirstTermPercentMarks}%)
                                  {item.FirstTermClass_Position}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td
                        style={{
                          width: "48%",
                          verticalAlign: "top",
                          padding: "0 6pt",
                        }}
                      >
                        <ul className="stars-list">
                          <li>
                            <i className="ri-star-fill"></i>
                            <span>Experiencing Significent Difficulty</span>
                          </li>
                          <li>
                            <i className="ri-star-fill"></i>
                            <span>Managing Comfortably</span>
                          </li>
                          <li>
                            <i className="ri-star-fill"></i>
                            <span>Capable and Competent</span>
                          </li>
                          <li>
                            <i className="ri-star-fill"></i>
                            <span>Highly Capable and Competent</span>
                          </li>
                        </ul>

                        <table className="table-bordered learning-starts">
                          <colgroup>
                            <col className="learning-label-col" />
                            <col className="learning-star-col" />
                            <col className="learning-star-col" />
                            <col className="learning-star-col" />
                            <col className="learning-star-col" />
                          </colgroup>
                          <thead>
                            <tr className="greyback">
                              <th colSpan="5">
                                Your Child's Learning During 1st Semester
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="learning-label">English / Urdu</td>
                              <td className="learning-star">
                                <i className="ri-star-fill"></i>
                              </td>
                              <td className="learning-star">
                                <i className="ri-star-fill"></i>
                              </td>
                              <td className="learning-star">
                                <i className="ri-star-fill"></i>
                              </td>
                              <td className="learning-star">
                                <i className="ri-star-fill"></i>
                              </td>
                            </tr>
                            <tr>
                              <td className="learning-label">Listening Comprehension</td>
                              <td className="learning-star"></td>
                              <td className="learning-star"></td>
                              <td className="learning-star"></td>
                              <td className="learning-star"></td>
                            </tr>
                            <tr>
                              <td className="learning-label">Oral Expression / Speaking</td>
                              <td className="learning-star"></td>
                              <td className="learning-star"></td>
                              <td className="learning-star"></td>
                              <td className="learning-star"></td>
                            </tr>
                            <tr>
                              <td className="learning-label">Reading</td>
                              <td className="learning-star"></td>
                              <td className="learning-star"></td>
                              <td className="learning-star"></td>
                              <td className="learning-star"></td>
                            </tr>
                            <tr>
                              <td className="learning-label">Written Expression</td>
                              <td className="learning-star"></td>
                              <td className="learning-star"></td>
                              <td className="learning-star"></td>
                              <td className="learning-star"></td>
                            </tr>
                          </tbody>
                        </table>
                        <div className="remarks">
                          <h4 style={{ margin: "0" }}>Teacher's Remarks</h4>
                          <div>
                            <div className="option">
                              <span className="value">&nbsp;</span>
                            </div>
                            <div
                              className="option"
                              style={{ marginTop: "5px" }}
                            >
                              <span className="value">&nbsp;</span>
                            </div>
                            <div
                              className="option"
                              style={{ marginTop: "5px" }}
                            >
                              <span className="value">&nbsp;</span>
                            </div>
                            <div
                              className="option"
                              style={{ marginTop: "5px" }}
                            >
                              <span className="value">&nbsp;</span>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="rc-footer">
                <table>
                  <tbody>
                    <tr>
                      <td style={{ width: "33%" }}>
                        <div className="option">
                          <span className="label">Prepared By:</span>
                          <span className="value"></span>
                        </div>
                      </td>
                      <td style={{ width: "33%" }}>
                        <h4>Controller Examination</h4>
                        <img
                          src="/images/signatures/controlexams.png"
                          style={{
                            width: "100px",
                            border: "0px",
                            marginTop: "-86px",
                            marginBottom: "0px",
                            marginRight: "0px",
                          }}
                          alt=""
                        />
                      </td>
                      <td style={{ width: "33%" }}>
                        <h4>Principal</h4>
                        <img
                          src="/images/signatures/principal.png"
                          style={{
                            width: "135px",
                            border: "0px",
                            float: "right",
                            marginTop: "-70px",
                            marginLeft: "-85px",
                            marginBottom: "0px",
                            marginRight: "0px",
                          }}
                          alt=""
                        />
                      </td>
                    </tr>
                    <tr>
                      <td colspan="3" style={{ fontSize: "9pt" }}>
                        <br />
                        Note: This provisional result intimation is issued as a
                        notice only. Errors and omissions are accepted.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </Page>
          );
        })
      )}
    </>
  );
};

export default PrintResultCards;
